import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-666b111e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tools" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "DEV TOOLS", -1))
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgs, (img) => {
        return (_openBlock(), _createElementBlock("a", {
          href: img.href,
          target: "_blank",
          key: img.key
        }, [
          _createElementVNode("img", {
            class: "img-thumbnail",
            src: require(`../../assets/tools/${img.src}`),
            alt: ""
          }, null, 8, _hoisted_5)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}